import { reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import api from '@/api/'

function getDepartment(options, line_id) {
  const platList = []
  const findPlat = (options, line_id) => {
    if (!Array.isArray(options)) return platList
    options.map(item => {
      if (String(item.parent_id) === String(line_id)) {
        platList.push(item)
        findPlat(options, item.id)
      }
    })
  }
  findPlat(options, line_id)
  return platList
}

export default () => {
  const _this = getCurrentInstance()
  const state = reactive({
    line_id: _this.$route.query.line_id, // 业务线id
    template_id: _this.$route.query.template_id, // 模板id
    platformList: [], // 平台列表
  })

  const selfPlatformList = computed(() => {
    if (state.line_id && state.platformList.length) {
      let childList = []
      const parentPlatformList = state.platformList.filter(item => String(item.id) === String(state.line_id))
      if (Array.isArray(parentPlatformList) && parentPlatformList.length) {
        childList = getDepartment(state.platformList, parentPlatformList[0].id)
      }
      return [...parentPlatformList, ...childList]
    }
    return []
  })

  onMounted(() => {
    methods.getPlatform()
  })

  const methods = {
    // 获取发布平台列表
    getPlatform: async function () {
      const res = await api.LineListNew()
      state.platformList = res.data
    },
  }

  return {
    selfPlatformList,
    ...toRefs(state),
    ...methods
  }
}
